import Swal from "sweetalert2";
import * as Cesium from 'cesium';
import styled from "styled-components";
import FormField from "../../../FormField";
import IonInterface from "utils/IonInterface";
import TextButton from "components/TextButton";
import { ArrowBack } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import TooltipIconButton from "components/TooltipIconButton";
import useProjectStore from "../../../../store-zustand/project";
import SidebarHeader from "components/Sidebar/layout/SidebarHeader";

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
`;

const Title = styled.h2`
  color: white;
`;

const SubTitle = styled.h3`
  font-size: 20px;
  line-height: 23px;
  color: #E5E5E5;
  margin-bottom: 21px;
  padding: 0 0 21px;
  border-bottom: 1px solid #A0A0A0;
`;

const Description = styled.div`
  p {
    color: #C4C4C4;
    &.drag {
      margin-bottom: 15px;
    }
    a {
      text-decoration: underline;
    }
  }
`;

const DownloadItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  &:hover {
    background-color: #262626;
  }
  span {
    font-family: Roboto;    
    font-weight: 500;
    font-size: 15px;
    line-height: 23px;
    color: #A0A0A0;
    &.selected {
      color: #E5E5E5;
    }
  }
  .actions {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const LocalUpload = ({ types, onClose, selectedType, onBack }) => {
  const [name, setName] = useState();
  const [ionAssets, setIonAssets] = useState([]);
  const [selectedItemID, setSelectedItemID] = useState();
  const profile = useSelector(state => state.profile.profile);
  const selectedIonAsset = useSelector(state => state.asset.selectedIonAsset);
  const { getUserOrgIonKeys, addAssetToProject, project_id, editProjectAsset, reloadAssetList, setreloadAssetList } = useProjectStore();
  const dispatch = useDispatch();

  const handleName = (e) => {
    setName(e.target.value);
  };

  const showErrorModal = (error_message) => {
    withReactContent(Swal).fire({
      icon: 'error',
      title: 'Error',
      html : `${error_message}`
    });
  };

  const removeAllAssets = () => {
    if (!window.assets) return;
    Object.keys(window.assets).map(id => {
      if (window.assets[id]?.type == "3DTILES") {
        window.MAIN_CESIUM_VIEWER.scene.primitives.remove(window.assets[id]);
      } else if (window.assets[id]?.type == "IMAGERY") {
        window.MAIN_CESIUM_VIEWER.imageryLayers.remove(window.assets[id]);
      } else if (window.assets[id]?.type == "TERRAIN") {
        window.MAIN_CESIUM_VIEWER.terrainProvider = new Cesium.EllipsoidTerrainProvider();
      } else if (window.assets[id]?.type == "GLTF") {
        window.MAIN_CESIUM_VIEWER.entities.remove(window.assets[id]);
      } else if (window.assets[id]?.type === "KML" || window.assets[id]?.type === "GEOJSON") {
        window.MAIN_CESIUM_VIEWER.dataSources.remove(window.assets[id]);
      }

      delete (window.assets[id]);
    })
  }

  const removeItem = (id) => {
    if (!window.assets) return;
    if (window.assets[id]?.type == "3DTILES") {
      window.MAIN_CESIUM_VIEWER.scene.primitives.remove(window.assets[id]);
    } else if (window.assets[id]?.type == "IMAGERY") {
      window.MAIN_CESIUM_VIEWER.imageryLayers.remove(window.assets[id]);
    } else if (window.assets[id]?.type == "TERRAIN") {
      window.MAIN_CESIUM_VIEWER.terrainProvider = new Cesium.EllipsoidTerrainProvider();
    } else if (window.assets[id]?.type == "GLTF") {
      window.MAIN_CESIUM_VIEWER.entities.remove(window.assets[id]);
    } else if (window.assets[id]?.type === "KML" || window.assets[id]?.type === "GEOJSON") {
      window.MAIN_CESIUM_VIEWER.dataSources.remove(window.assets[id]);
    }

    delete (window.assets[id]);
  }

  useEffect(() => {
    removeAllAssets();
    if (selectedIonAsset) {
      setName(selectedIonAsset.name);
      setSelectedItemID(selectedIonAsset.assetID);
    }

    var promises = [];
    if (profile.organizations && profile.organizations.length > 0) {
      getUserOrgIonKeys().then((response) => {
        response?.keys?.map((key) => {
          promises.push(
            IonInterface.instance.getAssets(key.TokenKey).then((response) => {
              var tokenAssets = response.data.items.filter(item => {
                if (selectedType.id === 1 && item.type === "3DTILES") return item;
                else if (selectedType.id === 2 && item.type === "IMAGERY") return item;
                else if (selectedType.id === 3 && item.type === "GLTF") return item;
                else if (selectedType.id === 4 && item.type === "TERRAIN") return item;
                else if (selectedType.id === 5 && (item.type === "CZML" || item.type === "KML" || item.type === "GEOJSON")) return item;
              });
              tokenAssets.forEach(item => {
                item.token = key;
              });
              return tokenAssets;
            })
          );
        })
        Promise.all(promises).then((responses) => {
          var assets = [];
          assets = assets.concat(...responses)
          setIonAssets(assets);
        })
      })
    } else {
      const publicToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJlYjJkMGNmNi02MDg1LTRmNzQtOWM4ZS1mNTJhNjZkMTE5ZTciLCJpZCI6MTEzNDUsImlhdCI6MTY0ODE4MTU5N30.9kaSFQrWesFvuutBnW77wzuvTqS9VUmz_aoS9f6HxiI";
      promises.push(
        IonInterface.instance.getAssets(publicToken).then((response) => {
          var tokenAssets = response.data.items.filter(item => {
            if (selectedType.id === 1 && item.type === "3DTILES") return item;
            else if (selectedType.id === 2 && item.type === "IMAGERY") return item;
            else if (selectedType.id === 3 && item.type === "GLTF") return item;
            else if (selectedType.id === 4 && item.type === "TERRAIN") return item;
            else if (selectedType.id === 5 && (item.type === "CZML" || item.type === "KML" || item.type === "GEOJSON")) return item;
          });
          tokenAssets.forEach(item => {
            item.token = publicToken;
          });
          return tokenAssets;
        })
      );

      Promise.all(promises).then((responses) => {
        var assets = [];
        assets = assets.concat(...responses)
        setIonAssets(assets);
      })
    }
  }, [])

  const addIonItem = (item) => {
    if (selectedItemID === item.id) {
      setSelectedItemID();
      removeItem(item.id);
    } else {
      setSelectedItemID(item.id);
      removeItem(selectedItemID);

      if (!window.assets) window.assets = {};
      if (item.type === "3DTILES") {
        Cesium.IonResource.fromAssetId(item.id, { accessToken: item.token.TokenKey }).then((resource) => {
          Cesium.Cesium3DTileset.fromUrl(resource).then(tileset => {
              window.assets[item.id] = tileset;
              window.assets[item.id].type = "3DTILES";
              window.MAIN_CESIUM_VIEWER.scene.primitives.add(tileset);
              window.MAIN_CESIUM_VIEWER.flyTo(tileset);
            });
        }).catch(() => {
          showErrorModal('Failed to retrieve the 3D Tileset Resource from Cesium Ion.');
          setSelectedItemID();
          removeItem(item.id);
        });
      } else if (item.type === "IMAGERY") {
        Cesium.IonImageryProvider.fromAssetId(item.id, { accessToken: item.token.TokenKey }).then(resource => {
          const imageLayer = window.MAIN_CESIUM_VIEWER.imageryLayers.addImageryProvider(resource, 1);
          window.assets[item.id] = imageLayer;
          window.assets[item.id].type = "IMAGERY";
        }).catch(() => {
          showErrorModal('Failed to retrieve the Imagery Resource from Cesium Ion.');
          setSelectedItemID();
          removeItem(item.id);
        });
      } else if (item.type === "TERRAIN") {
        Cesium.IonResource.fromAssetId(item.id, { accessToken: item.token.TokenKey }).then(resource => {
          Cesium.CesiumTerrainProvider.fromUrl(resource).then(terrain => {
            window.MAIN_CESIUM_VIEWER.terrainProvider = terrain;
            window.assets[item.id] = terrain;
            window.assets[item.id].type = "TERRAIN";
          });
        }).catch(() => {
          showErrorModal('Failed to retrieve the Terrain Resource from Cesium Ion.');
          setSelectedItemID();
          removeItem(item.id);
        });
      } else if (item.type === "GLTF") {
        Cesium.IonResource.fromAssetId(item.id, { accessToken: item.token.TokenKey }).then((resource) => {
          window.assets[item.id] = window.MAIN_CESIUM_VIEWER.entities.add({
            position: Cesium.Cartesian3.fromDegrees(0, 0, 100),
            model: {
              uri: resource,
            },
          });
          window.assets[item.id].type = "GLTF";
          window.MAIN_CESIUM_VIEWER.flyTo(window.assets[item.id]);
        }).catch(() => {
          showErrorModal('Failed to retrieve the 3D Model Resource from Cesium Ion.');
          setSelectedItemID();
          removeItem(item.id);
        });
      } else if (item.type === "KML") {
        Cesium.IonResource.fromAssetId(item.id, { accessToken: item.token.TokenKey }).then((resource) => {
          return Cesium.KmlDataSource.load(resource, {
            camera: window.MAIN_CESIUM_VIEWER.scene.camera,
            canvas: window.MAIN_CESIUM_VIEWER.scene.canvas,
          });
        }).then((dataSource) => {
          window.assets[item.id] = dataSource;
          window.assets[item.id].type = "KML";
          window.MAIN_CESIUM_VIEWER.dataSources.add(dataSource);
          window.MAIN_CESIUM_VIEWER.flyTo(window.assets[item.id]);
        }).catch(() => {
          showErrorModal('Failed to retrieve the KML Resource from Cesium Ion.');
          setSelectedItemID();
          removeItem(item.id);
        });
      } else if (item.type === "GEOJSON") {
        Cesium.IonResource.fromAssetId(item.id, { accessToken: item.token.TokenKey }).then((resource) => {
            return Cesium.GeoJsonDataSource.load(resource);
        }).then((dataSource) => {
          window.assets[item.id] = dataSource
          window.assets[item.id].type = "GEOJSON";
          window.MAIN_CESIUM_VIEWER.dataSources.add(dataSource);
          window.MAIN_CESIUM_VIEWER.flyTo(window.assets[item.id]);
          window.MAIN_CESIUM_VIEWER.scene.globe.depthTestAgainstTerrain = true;
        }).catch(() => {
          showErrorModal('Failed to retrieve the GeoJSON Resource from Cesium Ion.');
          setSelectedItemID();
          removeItem(item.id);
        });
      }
    }
  }

  const addToProject = () => {
    if (!selectedIonAsset) {
      var selectedAsset = ionAssets.find(item => item.id === selectedItemID);
      addAssetToProject(selectedAsset.id, selectedAsset.type, selectedAsset.token.TokenKey, project_id, !!name ? name : selectedAsset.name).then((response) => {
        if (response && response !== 500 && response !== 404) {
          dispatch({ type: 'SET_PROJECT_PANEL', panel: "Single" });
          setreloadAssetList(!reloadAssetList);
        } else {
          showErrorModal('Failed to save asset to the project.');
        }
      })
    } else {
      var selectedAsset = ionAssets.find(item => item.id == selectedIonAsset.assetID);
      editProjectAsset(selectedIonAsset.ID, selectedAsset.id, selectedAsset.type, !!name ? name : selectedAsset.name, selectedAsset.token.TokenKey).then((response) => {
        if (response && response !== 500 && response !== 404) {
          dispatch({ type: 'SET_PROJECT_PANEL', panel: "Single" });
          setreloadAssetList(!reloadAssetList);
        } else {
          showErrorModal('Failed to update asset.');
        }
      })
    }
  }

  return (
    <>
      <SidebarHeader onClose={onClose}>
        <TooltipIconButton title="Back" ariaLabel="back" placement="bottom" onClick={onBack} size={44}>
          <ArrowBack />
        </TooltipIconButton>
      </SidebarHeader>
      <TitleSection>
        <Title>{`Add ${selectedType.label}`}</Title>
        <TextButton text="Add to Project" onClick={addToProject} />
      </TitleSection>
      <FormField label="Asset Name">
        <input type="text" placeholder="Enter Asset Name" value={name} onChange={handleName} />
      </FormField>
      <SubTitle style={{ marginTop: 20 }}>
        Select Ion Items
      </SubTitle>
      {ionAssets?.map((item, index) => (
        <DownloadItem key={index}>
          <span>{item.name}</span>
          <div className="actions custom-checkbox">
            <input type="checkbox" id={`checkbox-` + index} checked={selectedItemID == item.id} onChange={() => addIonItem(item)} />
            <label htmlFor={`checkbox-` + index} />
          </div>
        </DownloadItem>
      ))}
      <Description>
        <p className="contact">Looking for a custom map data or a web map service provider?  <a href="mailto:sales@fastmap.ca">Contact Sales</a></p>
      </Description>
    </>
  );
}

export default LocalUpload;